import { render } from "./MySound.vue?vue&type=template&id=7fdfc45a"
import script from "./MySound.vue?vue&type=script&lang=js"
export * from "./MySound.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__